<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import { loadDataFromApi } from '@/services/api/load'
import FadeTransition from '@/components/FadeTransition.vue'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import { useSyncStore } from '@/stores/sync'
import { useToast } from 'vue-fomantic-ui'

const { toast } = useToast()
const syncStore = useSyncStore()

const MAX_SYNC_INTERVAL = 60000
const DELAY_BEFORE_SYNC = 1000 // This is to ensure reloading data is done after possible POST requests on focus event
let syncInProgress = false
let lastSync = 0

const syncData = async () => {
  if (syncInProgress) return
  syncInProgress = true

  try {
    const dataSynced = await syncStore.syncData()
    if (dataSynced) {
      toast({
        position: 'centered',
        message: `Les données ont été synchronisées avec le serveur.`,
        type: 'success',
      })
    }

    const now = Date.now()
    if (dataSynced || now - lastSync > MAX_SYNC_INTERVAL) {
      await loadDataFromApi()
      lastSync = now
    }
  } catch (e) {
    console.error(e.message)
  } finally {
    syncInProgress = false
  }
}

const syncDataWithDelay = () => setTimeout(syncData, DELAY_BEFORE_SYNC)

onMounted(() => {
  syncData()
  window.addEventListener('online', syncData)
  window.addEventListener('focus', syncDataWithDelay)
})
onBeforeUnmount(() => {
  window.removeEventListener('online', syncData)
  window.removeEventListener('focus', syncDataWithDelay)
})
</script>

<template>
  <div class="wrapper">
    <Header />
    <main>
      <RouterView v-slot="{ Component }">
        <FadeTransition>
          <component :is="Component" />
        </FadeTransition>
      </RouterView>
    </main>
    <Footer />
  </div>
</template>

<style scoped lang="scss">
.wrapper {
  height: 100%;

  header {
    height: 18%;
  }
  main {
    height: 72%;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
  }
  footer {
    height: 10%;
  }
}
</style>
